var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "console-terms",
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "max-width": "auto",
      "width": "100%"
    }
  }, [_c('v-row', {
    staticClass: "mt-8",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pt-0 pb-0 headline text-start",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("메인 빅데이터 카운트 관리")]), _c('v-spacer')], 1), _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-card-text', {
    staticClass: "py-3"
  }, [_c('v-row', [_c('div', {
    staticClass: "mx-4"
  }, [_c('span', {
    staticClass: "caption primary--text"
  }, [_vm._v("* 숫자만 기입 가능합니다.")])])]), _c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "(주)이레아이에스 국내 사용지역",
      "persistent-placeholder": "",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.main.domesitc,
      callback: function callback($$v) {
        _vm.$set(_vm.main, "domesitc", $$v);
      },
      expression: "main.domesitc"
    }
  })], 1), _c('v-col', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "(주)이레아이에스 해외 사용지역",
      "persistent-placeholder": "",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.main.overseas,
      callback: function callback($$v) {
        _vm.$set(_vm.main, "overseas", $$v);
      },
      expression: "main.overseas"
    }
  })], 1), _c('v-col', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "사용 농가",
      "persistent-placeholder": "",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.main.farmhouse,
      callback: function callback($$v) {
        _vm.$set(_vm.main, "farmhouse", $$v);
      },
      expression: "main.farmhouse"
    }
  })], 1), _c('v-col', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "농가 데이터 센서 수",
      "persistent-placeholder": "",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.main.data,
      callback: function callback($$v) {
        _vm.$set(_vm.main, "data", $$v);
      },
      expression: "main.data"
    }
  })], 1), _c('v-col', [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "1일 데이터 수집량",
      "persistent-placeholder": "",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.main.dataCollection,
      callback: function callback($$v) {
        _vm.$set(_vm.main, "dataCollection", $$v);
      },
      expression: "main.dataCollection"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }